import React from "react"

import { FilesTable } from "@/components/Tables/Aeros/components/FilesTable"
import type { SignedUrl } from "@/graphql/codegen/graphql"
import { useGoodsReceiptFileColumns } from "@/screens/WarehouseReceiving/hooks/useGoodsReceiptFileColumns"

interface GoodsReceiptUploadsTableProps {
  data: SignedUrl[]
  isLoading: boolean
  error?: Error
  onRemove: (fileId: string) => Promise<boolean>
}

export const GoodsReceiptUploadsTable: React.FC<GoodsReceiptUploadsTableProps> = ({
  data,
  isLoading,
  error,
  onRemove,
}) => {
  const columns = useGoodsReceiptFileColumns(onRemove)

  return (
    <FilesTable
      data={data}
      isLoading={isLoading}
      columns={columns}
      error={error}
      noDataMessage='No goods receipt documents found'
    />
  )
}
